const scrollSnapType = {
    name: "scroll-snap-type",
    path: "scroll-snap-type",
    title: "scroll-snap-type",
    description: "Utilities for controlling how strictly snap points are enforced in a snap container.",
    value: {
        'scroll-snap-type': {
            'snap-none': 'none',
            'snap-x': 'x',
            'snap-x-mandatory': 'x mandatory',
            'snap-x-proximity': 'x proximity',
            'snap-y': 'y',
            'snap-y-mandatory': 'y mandatory',
            'snap-y-proximity': 'y proximity',
            'snap-block': 'block',
            'snap-block-mandatory': 'block mandatory',
            'snap-block-proximity': 'block proximity',
            'snap-inline': 'inline',
            'snap-inline-mandatory': 'inline mandatory',
            'snap-inline-proximity': 'inline proximity',
            'snap-both': 'both',
            'snap-both-mandatory': 'both mandatory',
            'snap-both-proximity': 'both proximity',
        },
    },
exampleData: [
        {
            "title": "snap-x",
            "description": "utility together with the snap-mandatory utility to force a snap container to always stop on an element before the user can continue scrolling to the next item:",
            "moreDescription": "",
            "parentClass": "relative flex w-full snap-x gap-6 overflow-x-auto py-10 !bg-none !border-0",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                ],
                "className": "relative snap-center shrink-0",
                "code": `<div class="snap-x ...">
  <div class="snap-center ...">
    <img src="/img/image-01.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-02.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-03.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-04.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-05.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-06.jpg" />
  </div>
</div>`
            }
        },
        {
            "title": "snap-x-mandatory",
            "description": " utility to snap an element to its start when being scrolled inside a snap container:",
            "moreDescription": "",
            "parentClass": "relative flex w-full snap-x-mandatory gap-6 overflow-x-auto py-10 !bg-none !border-0",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                ],
                "className": "relative snap-center shrink-0",
                "code": `<div class="snap-x-mandatory  ...">
  <div class="snap-center ...">
    <img src="/img/image-01.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-02.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-03.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-04.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-05.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-06.jpg" />
  </div>
</div>`
            }
        }
    ]
};

export default scrollSnapType;